import { Checkbox, getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import React from 'react'
import Trns from 'src/localization/Trns'
import { OrgExpenseReportStatus } from 'src/models/orgExpenseReports.models'
import { css } from 'styled-components'

interface TransactionReviewStatusFilterProps {
  reviewStatusSet: Set<string>
  handleReviewStatusesSelection: (status: string) => Set<string>
}

const TransactionReviewStatusFilter: React.FC<TransactionReviewStatusFilterProps> = ({
  reviewStatusSet,
  handleReviewStatusesSelection,
}) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        <Trns source={'Review Status'} />
      </div>
      <Checkbox
        label={<Trns source={'Flagged'} />}
        onClick={(): void => {
          handleReviewStatusesSelection(
            OrgExpenseReportStatus.Flagged,
          )
        }}
        isSelected={reviewStatusSet.has(
          OrgExpenseReportStatus.Flagged,
        )}
      />
      <Checkbox
        label={<Trns source={'Pending Review'} />}
        onClick={(): void => {
          handleReviewStatusesSelection(
            OrgExpenseReportStatus.PendingReview,
          )
        }}
        isSelected={reviewStatusSet.has(
          OrgExpenseReportStatus.PendingReview,
        )}
      />
      <Checkbox
        label={<Trns source={'Reviewed'} />}
        onClick={(): void => {
          handleReviewStatusesSelection(
            OrgExpenseReportStatus.Reviewed,
          )
        }}
        isSelected={reviewStatusSet.has(
          OrgExpenseReportStatus.Reviewed,
        )}
      />
    </div>
  )
}

export default TransactionReviewStatusFilter
